import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { 
  Wifi, 
  Tv, 
  Car, 
  Bike, 
  Shield, 
  Coffee,
  CheckCircle,
  Star
} from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      icon: Wifi,
      title: "Fibre Internet Gratuite",
      description: "Connexion haut débit dans tous les appartements pour rester connecté"
    },
    {
      icon: Tv,
      title: "TV Connectées",
      description: "Smart TV dans chaque logement avec accès aux plateformes de streaming"
    },
    {
      icon: Car,
      title: "Parking Privatif",
      description: "Stationnement sécurisé inclus pour tous nos résidents"
    },
    {
      icon: Bike,
      title: "Hangar à Vélos",
      description: "Espace de rangement sécurisé + location de vélos disponible"
    }
  ];

  const additionalServices = [
    "Linge de lit et serviettes fournis",
    "Ménage de fin de séjour inclus",
    "Réception et accueil personnalisé",
    "Service de conciergerie",
    "Informations touristiques"
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <Badge variant="secondary" className="px-4 py-2 text-sm font-medium bg-emerald-100 text-emerald-800 border-emerald-200 mb-4">
              <Star className="h-4 w-4 mr-2" />
              Services inclus
            </Badge>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Nos 
              <span className="bg-gradient-to-r from-emerald-600 to-emerald-600 bg-clip-text text-transparent"> Services</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Profitez d'un séjour tout confort dans nos appartements équipés et aménagés avec soin. Et profitez d'un service personnalisé pour curistes et vacanciers.
            </p>
          </div>

          {/* Services principaux */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {services.map((service, index) => (
              <Card key={index} className="text-center hover:shadow-xl transition-all duration-300 border-gray-200 hover:border-emerald-200 group">
                <CardContent className="p-6">
                  <div className="mb-4">
                    <service.icon className="h-12 w-12 text-emerald-600 mx-auto group-hover:scale-110 transition-transform duration-300" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Services supplémentaires */}
          <div className="bg-gradient-to-r from-emerald-50 to-emerald-50 rounded-2xl p-8 border border-emerald-100">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Services complémentaires</h3>
                <p className="text-gray-700 mb-6">
                  Au-delà de nos équipements, nous mettons tout en œuvre pour que votre séjour soit parfait.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {additionalServices.map((service, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <CheckCircle className="h-4 w-4 text-emerald-600 flex-shrink-0" />
                      <span className="text-gray-700 text-sm">{service}</span>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="bg-white p-6 rounded-xl shadow-lg">
                <h4 className="text-xl font-bold text-gray-900 mb-4">🚴‍♀️ Location de vélos</h4>
                <p className="text-gray-700 mb-4">
                  Explorez la région à vélo ! Nous proposons la location de vélos pour découvrir les environs à votre rythme.
                </p>
                <div className="bg-emerald-100 p-3 rounded-lg">
                  <p className="text-emerald-800 text-sm font-medium">
                    💡 Demandez nous conseils pour les circuits et balades alentours comme la mythique voie verte ou autres..
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;